import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api } from '../utils/api';

const OUTCOME_BADGE = {
  done:           { label: '✅ Done',           color: '#2dd4a0', bg: '#f0faf5' },
  carry_forward:  { label: '🔄 Carry Forward',  color: '#f5a623', bg: '#fff8ec' },
  dropped:        { label: '❌ Dropped',         color: '#e05252', bg: '#fff0f0' },
};

export default function TeamPage() {
  const { teamId } = useParams();
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState({});

  useEffect(() => {
    api.teamDashboard.get(teamId)
      .then(d => setSessions(Array.isArray(d) ? d : []))
      .catch(() => setSessions([]))
      .finally(() => setLoading(false));
  }, [teamId]);

  const toggleSession = id => setExpanded(e => ({ ...e, [id]: !e[id] }));

  if (loading) return <div style={{ padding: 32 }}>Loading...</div>;

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: 32 }}>
      <Link to="/" style={{ fontSize: 13, color: 'var(--text-muted)', textDecoration: 'none' }}>← Back</Link>
      <h1 style={{ marginTop: 16, marginBottom: 4, fontSize: 22 }}>Action Dashboard</h1>
      <p style={{ color: 'var(--text-muted)', fontSize: 13, marginBottom: 24 }}>Track what happened to previous retro commitments.</p>

      {sessions.length === 0 ? (
        <div style={{ color: 'var(--text-muted)', fontStyle: 'italic' }}>No completed sessions yet.</div>
      ) : sessions.map(session => {
        const actions = (session.retro_actions || []).filter(a => a.status === 'approved');
        const date = session.created_at ? new Date(session.created_at).toLocaleDateString() : '';
        return (
          <div key={session.id} className="card mb-3">
            <div
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
              onClick={() => toggleSession(session.id)}
            >
              <div>
                <div style={{ fontWeight: 700 }}>{session.name || 'Retro'}</div>
                <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{date} · {actions.length} action{actions.length !== 1 ? 's' : ''}</div>
              </div>
              <span style={{ color: 'var(--text-muted)' }}>{expanded[session.id] ? '▲' : '▼'}</span>
            </div>

            {expanded[session.id] && (
              <div style={{ marginTop: 12 }}>
                {actions.length === 0 ? (
                  <div style={{ color: 'var(--text-muted)', fontSize: 13, fontStyle: 'italic' }}>No approved actions.</div>
                ) : actions.map(action => {
                  const review = (action.retro_action_reviews || [])[0];
                  const badge = review ? OUTCOME_BADGE[review.outcome] : null;
                  return (
                    <div key={action.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0', borderBottom: '1px solid var(--border)' }}>
                      <span style={{ fontSize: 13 }}>{action.type === 'change' ? '🧪' : '⚡'} {action.content}</span>
                      {badge ? (
                        <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 100, background: badge.bg, color: badge.color, whiteSpace: 'nowrap', marginLeft: 8 }}>
                          {badge.label}
                        </span>
                      ) : (
                        <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 100, background: 'var(--bg-elevated)', color: 'var(--text-muted)', whiteSpace: 'nowrap', marginLeft: 8 }}>
                          ⏳ Pending review
                        </span>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
